"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isKetteUnionUnsafe = exports.isKetteUnion = void 0;
const Eskin_1 = require("./Eskin");
const RxRohr_1 = require("./RxRohr");
const TriflexR_1 = require("./TriflexR");
const Twisterband_1 = require("./Twisterband");
const Twisterchain_1 = require("./Twisterchain");
const StandardKette_1 = require("./StandardKette");
const RolEchainUnion_1 = require("../rolEchain/RolEchainUnion");
const Trxe_1 = require("./Trxe");
const isKetteUnion = (whatever, v) => (0, StandardKette_1.isStandardKette)(whatever, v) ||
    (0, Eskin_1.isEskin)(whatever, v) ||
    (0, RxRohr_1.isRxRohr)(whatever, v) ||
    (0, TriflexR_1.isTriflexR)(whatever, v) ||
    (0, Twisterband_1.isTwisterband)(whatever, v) ||
    (0, Twisterchain_1.isTwisterchain)(whatever, v) ||
    (0, RolEchainUnion_1.isRolEchainUnion)(whatever, v) ||
    (0, Trxe_1.isTrxe)(whatever, v);
exports.isKetteUnion = isKetteUnion;
const isKetteUnionUnsafe = (whatever, v) => (0, StandardKette_1.isStandardKette)(whatever, v) ||
    (0, Eskin_1.isEskin)(whatever, v) ||
    (0, RxRohr_1.isRxRohr)(whatever, v) ||
    (0, TriflexR_1.isTriflexR)(whatever, v) ||
    (0, Twisterband_1.isTwisterband)(whatever, v) ||
    (0, Twisterchain_1.isTwisterchain)(whatever, v) ||
    (0, RolEchainUnion_1.isRolEchainUnionUnsafe)(whatever, v) ||
    (0, Trxe_1.isTrxe)(whatever, v);
exports.isKetteUnionUnsafe = isKetteUnionUnsafe;
//# sourceMappingURL=KetteUnion.js.map